import { useCallback } from 'react';
import Promise from 'bluebird';

import { useCreateSafeAsyncToken } from './use-create-safe-async-token';

/**
 * a custom Hook that will return an auto-canceled Promise Creator
 * @param {function} promiseFunc - a function that will return a Promise when it's called
 *  with any args
 * @returns {function} a safe Promise creator that will be auto-canceled after a new promise
 *  is created or before the Hook wrapper is unmounted
 */
export const useCreateSafePromise = (promiseFunc) => {
  const createSafePromise = useCreateSafeAsyncToken(promiseFunc);
  return useCallback((...args) => new Promise((resolve, reject) => {
    createSafePromise(...args).on({
      onSuccess: resolve,
      onError: reject,
    });
  }), [createSafePromise]);
};
